import { useMemo } from "react";
import * as React from "react";
import { StyleSheet } from "react-native";

import { FormikStaticTextField, useTheme } from "@smartrent/ui";

import { useFormikFieldsHook } from "@/pages/hub-refurbish/hooks/useFormikFieldsHook";

import {
  HubRefurbishFormikFieldLabels,
  HubRefurbishFormikFieldNames,
  HubRefurbishReactQueryKeys,
} from "@/types/HubRefurbishProps";

import { useHubRefurbishContext } from "../HubRefurbishContext";

export const HubRefurbishJobFormikFieldSuccesses: React.VFC = () => {
  const { colors } = useTheme();
  const { getHubs } = useHubRefurbishContext();

  const successJobs = useMemo(
    () => getHubs((hub) => hub?.isSuccess),
    [getHubs]
  );

  // SUCCESS
  const { onClearCallback, containerStyle, labelStyle, disabled } =
    useFormikFieldsHook({
      required: true,
      name: HubRefurbishFormikFieldNames.Success,
      queryKey: HubRefurbishReactQueryKeys.HubRefurbishJob,
      value: successJobs,
    });

  return (
    <FormikStaticTextField
      style={styles.root}
      containerStyle={{
        ...containerStyle,
        ...{ backgroundColor: colors.successMutedBackground },
      }}
      labelStyle={{
        ...labelStyle,
        ...{ color: colors.successText },
      }}
      name={HubRefurbishFormikFieldNames.Success}
      label={HubRefurbishFormikFieldLabels.Success}
      onPress={() => null}
      transformValue={(value) => value?.length}
      onClear={onClearCallback}
      disabled={disabled}
    />
  );
};

const styles = StyleSheet.create({
  root: { maxWidth: 175 },
});
